var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "asta-order" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "navy headline" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "white--text", attrs: { left: "" } },
                    [_vm._v("settings_backup_restore")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "white--text" }, [
                    _vm._v("Ordine partecipanti"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", light: "", icon: "" },
                      on: { click: _vm.dismiss },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.asta_squadre && _vm._.size(_vm.asta_squadre) > 0
                ? _c(
                    "v-list",
                    {
                      staticClass: "overflow-y-auto mr-1 pr-1",
                      class: { "nice-scroll": !_vm.is_mobile },
                      attrs: { dense: "", "max-height": "450px" },
                    },
                    [
                      _c(
                        "draggable",
                        {
                          attrs: {
                            disabled: !this.admin || this.isAstaInCorso,
                            "ghost-class": "ghost",
                            animation: "150",
                            group: "asta-order",
                            delay: "80",
                            delayOnTouchOnly: "true",
                          },
                          model: {
                            value: _vm.asta_squadre_drag,
                            callback: function ($$v) {
                              _vm.asta_squadre_drag = $$v
                            },
                            expression: "asta_squadre_drag",
                          },
                        },
                        [
                          _c(
                            "transition-group",
                            { staticClass: "lista-squadre" },
                            _vm._l(_vm.asta_squadre_array, function (sq) {
                              return _c(
                                "v-list-item",
                                { key: sq.id, staticClass: "item" },
                                [
                                  _c("v-list-item-avatar", [
                                    _c("img", {
                                      attrs: { src: _vm.squadra(sq.id).pic },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-content", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(sq.name) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "navy--text",
                                      attrs: { left: "" },
                                    },
                                    [_vm._v("drag_indicator")]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "lista-vuota py-4" }, [
                    _vm._v("Nessuna squadra."),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }